import { v4 as uuidv4 } from 'uuid'
import JobTypes from '../helpers/JobTypesEnum'
import { STORAGE_PATH } from '../config'

const missTacaca = {
  id: uuidv4(),
  name: 'Miss Tacacá',
  path: '/miss-tacaca',
  bios: [
    'Artista natural de Belém do Pará, atua como DJ, produtora, modelo e performer. Seus sets eletrizantes e tórridos condensam e expandem a cultura paraense, incorporando manifestações do tecnobrega, tecnomelody, bregafunk, funk e eletrotechno. É também idealizadora e produtora geral da produtora Taka Night, que em colaboração com o coletivo MARSHA! realizou o 1º festival LGBTQIA+ online com line up só de artistas paraenses.',
    'Artist born in Belém do Pará, she works as a DJ, producer, model and performer. Her torrid and electrifying sets condense and expand on the culture of Pará, incorporating manifestations of tecnobrega, tecnomelody, bregafunk, funk and eletrotechno. She is also the creator and general producer of the production company Taka Night, which in collaboration with the collective MARSHA! held the 1st LGBTQIA+ online festival with a lineup composed of artists from Pará.',
  ],
  jobs: [
    {
      id: uuidv4(),
      title: 'TakaSound',
      type: JobTypes.AUDIO,
      path: '/taka-sound',
      image: '/assets/miss-tacaca/miss-tacaca.png',
      imageHover: '/assets/miss-tacaca/miss-tacaca_hover.png',
      texts: [
        'Vivências, imaginações, aparelhagens e o peso do Pará num set-visual-filme e numa faixa. Aventura-futurística de um presente escaldante. Imaginário travesti fortalecido e sempre em ascensão.', 
        'Experiences, imaginations, sound systems and the power of Pará in a visual-set-film and in a track. Transvestite in a scalding present. Transvestite imaginary strengthened and always on the rise.',
      ],
      pages: [
        {
          id: uuidv4(),
          type: JobTypes.VIDEO,
          link: 'Video',
          title: 'Miss Tacacá Set Visual Filme',
          src: `${STORAGE_PATH}/Miss+Tacacá/Miss+Tacacá+-+Set+Visual+Filme.mp4`,
          // src: 'https://firebasestorage.googleapis.com/v0/b/napkin-bd39e.appspot.com/o/videos%2FMISSTACACA_VIDEO.mp4?alt=media&token=28748954-14fa-4f8b-a4de-c79312449bf6',
          path: '/a-distancia',
          sizes: [5.3, 3],
        },
        {
          id: uuidv4(),
          link: 'Track',
          title: 'Utopias (feat. Malka)',
          src: `${STORAGE_PATH}/Miss+Tacacá/Miss+Tacacá+-+Utopias+(feat.+Malka).wav`,
          path: '/entao-e-natal',
        }
      ]
    },
  ],
}

export default missTacaca
